import { useEffect, useState } from 'react';

/**
 * Reactive browser connectivity. `navigator.onLine` + online/offline events.
 * Note: this reflects the OS/browser's link state, not whether the API is
 * actually reachable — it's a fast, conservative guard, not a health check.
 */
export function useOnline(): boolean {
  const [online, setOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const on = () => setOnline(true);
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => {
      window.removeEventListener('online', on);
      window.removeEventListener('offline', off);
    };
  }, []);

  return online;
}
